/**
* DevExpress Dashboard (_custom-item-metadata.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
export let editorTemplates = {
    radioGroup: 'radioGroup',
    image: 'image',
    text: 'text',
    bool: 'bool',
    boolYesNo: 'boolYesNo',
    boolVisibleHidden: 'boolVisibleHidden',
    boolDiscreteContinuous: 'boolDiscreteContinuous',
    checkBox: 'checkBox',
    list: 'list',
    numeric: 'numeric',
    date: 'data',
    combobox: 'combobox',
    buttonGroup: 'buttonGroup',
    guid: 'guid',
};
